import { api } from './apiService';
import type { ImportBatch } from '@/types/importBatch';

function rowToImportBatch(row: Record<string, unknown>): ImportBatch {
  return {
    id: row.id as string,
    label: row.label as string,
    source: row.source as string | undefined,
    itemCount: row.item_count != null ? Number(row.item_count) : 0,
    createdAt: row.created_at as string,
  };
}

export const importBatchApiService = {
  async list(): Promise<ImportBatch[]> {
    const { data } = await api.get<Record<string, unknown>[]>('/import-batches');
    return data.map(rowToImportBatch);
  },

  async delete(id: string): Promise<void> {
    await api.delete(`/import-batches/${id}`);
  },
};
